module.exports = __webpack_public_path__ + "static/img/tedian1.dd2ed01c.png";